module.exports = __webpack_public_path__ + "img/avatar-smoking.46a42869.png";